<div class="not-found-container">
  <h1>404 - {{ 'Page Not Found' | translate }}</h1>
  <p>{{ 'Oops' | translate }} !</p>
  <button mat-button class="home-btn" (click)="onRedirect()">
    {{ 'Go to Homepage' | translate }}
  </button>
</div>
